import { getTime, getScrollX, getScrollY } from '../ADNDHelpers'
import { getState, updateState } from '../ADNDState'

import RectHitTest from '../RectHitTest'
import RectVHitTest from '../RectVHitTest'

export const STAGE_STOPPED = 0
export const STAGE_INIT = 1
export const STAGE_FETCH = 10
export const STAGE_HIT_TEST_BAKE = 11
export const STAGE_UPDATE_DYNAMIC_TARGETS = 12
export const STAGE_STARTED = 100

export const UPDATE_DYNAMIC_TARGETS_TICK = 45

const props = {
  stage: STAGE_STOPPED,
  targets: {},
  type: null,
  fetched: 0,
  activeTargets: [],
  activeDynamicTargets: [],
  updateDynamicTargetsTickCounter: 0,
  currentTargetIndex: null,
  rectHitTest: null,
  zIndexRectHitTest: null,
  blackHoles: {},
  lastCursor: {
    x: null,
    y: null
  },
  lock: {
    x: null,
    y: null
  },
  hitShift: {
    x: 0,
    y: 0
  },
  started: false
}

const LAYER = {
  updatesState: true,
  start(/*event*/) {
    LAYER.setStage(STAGE_INIT)
    return LAYER
  },
  stop(/*event*/) {
    LAYER.setStage(STAGE_STOPPED)
    return LAYER
  },
  isStarted() {
    return props.started
  },
  setStage(stage) {
    props.stage = stage
    if (STAGE_STARTED == stage && !props.started) {
      // started
      props.started = true
      props.activeTargets.forEach(function (target) {
        if (target.PRIVATE.doStart) {
          target.PRIVATE.doStart()
        }
      })
    } else if (STAGE_STOPPED == stage || STAGE_INIT == stage) {
      // stopped
      const started = props.started
      props.started = false
      props.blackHoles = {}
      props.lastCursor.x = null
      props.lastCursor.y = null
      if (STAGE_STOPPED == stage) {
        LAYER.lockX(null)
        LAYER.lockY(null)
        props.rectHitTest = null
        props.zIndexRectHitTest = null
      } else if (STAGE_INIT == stage) {
        props.rectHitTest = null != props.lock.x ? RectVHitTest() : RectHitTest()
        props.zIndexRectHitTest = null
      }
      if (null != props.currentTargetIndex) {
        const currentTarget = props.activeTargets[props.currentTargetIndex]
        if (null != currentTarget) {
          currentTarget.PRIVATE.doLeave(getState())
        }
      }
      if (started) {
        props.activeTargets.forEach(function (target) {
          if (target.PRIVATE.doStop) {
            target.PRIVATE.doStop()
          }
        })
      }
      props.fetched = 0
      props.activeTargets = []
      props.activeDynamicTargets = []
      props.updateDynamicTargetsTickCounter = 0
      props.currentTargetIndex = null
    }
    return LAYER
  },
  getStage() {
    return props.stage
  },
  frame(state) {
    if (props.type != state.item.type) {
      props.type = state.item.type
      LAYER.setStage(STAGE_INIT)
      return state
    }
    switch (props.stage) {
      case STAGE_INIT: {
        return LAYER.setStage(STAGE_FETCH).frame(state)
      }
      case STAGE_FETCH: {
        fetchTargets()
        return state
      }
      case STAGE_HIT_TEST_BAKE: {
        if (props.activeTargets.length && null != props.rectHitTest) {
          props.activeTargets.forEach(function (target, index) {
            props.rectHitTest.add(index, target.props.rect)
            if (target.props.zIndex > 0) {
              if (null == props.zIndexRectHitTest) {
                props.zIndexRectHitTest = RectHitTest()
              }
              props.zIndexRectHitTest.add(index, target.props.rect, target.props.zIndex)
            }
          })
          props.rectHitTest.bake()
          if (null != props.zIndexRectHitTest) {
            props.zIndexRectHitTest.bake()
          }
        }
        LAYER.setStage(null == props.rectHitTest || props.rectHitTest.isEmpty() ? STAGE_STOPPED : STAGE_STARTED)
        return state
      }
      case STAGE_UPDATE_DYNAMIC_TARGETS: {
        if (props.activeDynamicTargets.length) {
          let targetsUpdated = false
          for (let index = 0; index < props.activeDynamicTargets.length; index++) {
            const dynamicTargetIndex = props.activeDynamicTargets[index]
            const target = props.activeTargets[dynamicTargetIndex]
            if (null != target) {
              target.PRIVATE.fetchRect()
              if (null != target.props.rect) {
                props.rectHitTest.update(dynamicTargetIndex, target.props.rect)
                targetsUpdated = true
                if (target.props.zIndex > 0 && null != props.zIndexRectHitTest) {
                  props.zIndexRectHitTest.update(dynamicTargetIndex, target.props.rect, target.props.zIndex)
                }
              }
            }
          }
          if (targetsUpdated) {
            props.lastCursor.x = null
            props.lastCursor.y = null
          }
        }
        LAYER.setStage(STAGE_STARTED)
        return state
      }
      case STAGE_STARTED: {
        if (props.activeDynamicTargets.length) {
          props.updateDynamicTargetsTickCounter++
          if (UPDATE_DYNAMIC_TARGETS_TICK <= props.updateDynamicTargetsTickCounter) {
            props.updateDynamicTargetsTickCounter = 0
            LAYER.setStage(STAGE_UPDATE_DYNAMIC_TARGETS)
            return state
          }
        }
        // apply locks
        let x = null == props.lock.x ? state.cursor.x : props.lock.x
        let y = null == props.lock.y ? state.cursor.y : props.lock.y
        // apply black holes
        let shiftX = 0
        let shiftY = 0
        for (const blackHoleId in props.blackHoles) {
          const blackHole = props.blackHoles[blackHoleId]
          if (
            (null == blackHole.top ? true : y >= blackHole.top) &&
            (null == blackHole.left ? true : x >= blackHole.left)
          ) {
            if (null != blackHole.bottom && null != blackHole.top) {
              shiftY += y < blackHole.bottom ? blackHole.top - y : blackHole.top - blackHole.bottom
            }
            if (null != blackHole.right && null != blackHole.left) {
              shiftX += x < blackHole.right ? blackHole.left - x : blackHole.left - blackHole.right
            }
            if (null != blackHole.height) {
              shiftY += blackHole.height
            }
            if (null != blackHole.width) {
              shiftX += blackHole.width
            }
          }
        }
        x += shiftX
        y += shiftY
        // rect hit test
        if (x != props.lastCursor.x || y != props.lastCursor.y) {
          if (null != props.rectHitTest) {
            const hitX = x + props.hitShift.x
            const hitY = y + props.hitShift.y
            const hitTargetIndex =
              null != props.zIndexRectHitTest
                ? props.zIndexRectHitTest.test(
                    state.cursor.x + props.hitShift.x + shiftX,
                    state.cursor.y + props.hitShift.y + shiftY
                  ) || props.rectHitTest.test(hitX, hitY)
                : props.rectHitTest.test(
                    state.cursor.x + props.hitShift.x + shiftX,
                    state.cursor.y + props.hitShift.y + shiftY
                  )
            if (hitTargetIndex != props.currentTargetIndex) {
              const lastTarget = null != props.currentTargetIndex ? props.activeTargets[props.currentTargetIndex] : null
              const hitTarget =
                null != hitTargetIndex ? props.activeTargets[hitTargetIndex] : lastTarget.capture ? lastTarget : null
              if (lastTarget != hitTarget) {
                if (null != lastTarget) {
                  lastTarget.PRIVATE.doLeave(state)
                }
                if (null != hitTarget) {
                  hitTarget.PRIVATE.doEnter(state)
                }
                props.currentTargetIndex = hitTargetIndex
                state.target.current = hitTarget
              }
            }
            if (null != state.target.current && state.target.current.PRIVATE.hitTest) {
              state.target.current = state.target.current.PRIVATE.hitTest(hitX, hitY)
            }
          }
          props.lastCursor.x = x
          props.lastCursor.y = y
        }
        return state.target.current && state.target.current.PRIVATE && state.target.current.PRIVATE.frame
          ? state.target.current.PRIVATE.frame(state)
          : state
      }
      default: {
        return state
      }
    }
  },
  drop(_state, event) {
    if (null != props.currentTargetIndex) {
      const currentTarget = props.activeTargets[props.currentTargetIndex]
      if (null != currentTarget) {
        const state = updateState(function (state) {
          state.stage = 'dropped'
          return state
        })
        currentTarget.PRIVATE.doDrop(state, event)
      }
    }
    return LAYER
  },
  addTarget(type, target) {
    if (null != type) {
      if (null == props.targets[type]) {
        props.targets[type] = []
      }
      if (!props.targets[type].includes(target)) {
        props.targets[type].push(target)
        if (STAGE_STOPPED != props.stage) {
          LAYER.setStage(STAGE_INIT)
        }
      }
    }
    return LAYER
  },
  removeTarget(type, target) {
    if (null != type && null != props.targets[type]) {
      const targetIndex = props.targets[type].indexOf(target)
      if (targetIndex >= 0) {
        props.targets[type].splice(targetIndex, 1)
        if (STAGE_STOPPED != props.stage) {
          LAYER.setStage(STAGE_INIT)
        }
      }
    }
    return LAYER
  },
  lockX(value) {
    props.lock.x = null == value ? null : parseFloat(value)
    if (isNaN(props.lock.x)) {
      props.lock.x = null
    }
    return LAYER
  },
  lockY(value) {
    props.lock.y = null == value ? null : parseFloat(value)
    if (isNaN(props.lock.y)) {
      props.lock.y = null
    }
    return LAYER
  },
  hitShift(x = 0, y = 0) {
    props.hitShift.x = x
    props.hitShift.y = y
    return LAYER
  },
  setBlackHole(id, blackHole) {
    props.blackHoles[id] = blackHole
    return LAYER
  },
  removeBlackHole(id) {
    if (void 0 !== props.blackHoles[id]) {
      delete props.blackHoles[id]
    }
    return LAYER
  }
}

function fetchTargets() {
  if (null == props.type) {
    LAYER.setStage(STAGE_STOPPED)
    return
  }
  const targets = props.targets[props.type]
  if (null == targets || targets.length == props.fetched) {
    LAYER.setStage(STAGE_HIT_TEST_BAKE)
  } else {
    const startTime = getTime()
    const scrollX = getScrollX()
    const scrollY = getScrollY()
    while (props.fetched < targets.length) {
      const target = targets[props.fetched]
      if (target.PRIVATE.acceptDrop(props.type)) {
        target.PRIVATE.fetchRect(scrollX, scrollY)
        props.activeTargets.push(target)
        if (target.props.dynamicPosition) {
          props.activeDynamicTargets.push(props.activeTargets.length - 1)
        }
      }
      props.fetched++
      const iterationTime = getTime()
      if (iterationTime - startTime > 12) {
        // pass fetching rest targets to the next frame
        return
      }
    }
    LAYER.setStage(STAGE_HIT_TEST_BAKE)
  }
}

export default function ADNDTargetsLayer() {
  return LAYER
}
